@if (canView()) {
  <div class="dynamic-step-container">
    @if (step()?.step.type === SINGLE_SELECT_QUESTION) {
      <c-single-select
        [label]="question()?.title"
        [description]="question()?.description"
        [options]="question()?.options"
        [selectedOption]="answer()?.selectedOptions[0]"
        (select)="onOptionsSelected($event)" />

      @if (showValidationMessage()) {
        <p class="validation-message">{{ 'dynamic-flow.validation.single-select.required' | transloco }}</p>
      }
    } 
    
    @if (step()?.step.type === MULTI_SELECT_QUESTION) {
      <c-multi-select
        [label]="question()?.title"
        [description]="question()?.description"
        [options]="question()?.options"
        [selectedOptions]="answer()?.selectedOptions"
        (select)="onOptionsSelected($event)" />

      @if (showValidationMessage()) {
        <p class="validation-message">{{ 'dynamic-flow.validation.multi-select.required' | transloco }}</p>
      }
    } 

    @if (step()?.step.type === CONTENT) {
      <c-content-step 
        [content]="step().step.content" />
    }
    
    @if (step()?.step.type === LOCATION) {
      <c-location-step
        [location]="resolvedLocation()"
        [title]="step().step.location.title"
        [description]="step().step.location.description"
        [locationSuggestions]="locationSuggestions()"
        [showErrors]="showValidationMessage()"
        [currentLocationUsed]="currentLocationUsed()"
        (locationSearch)="onLocationSearch($event)"
        (locationSelected)="onLocationSelected($event)"
        (locationChanged)="onLocationChanged($event)"
        (currentLocationRequested)="onUseCurrentLocation()" />
    }

    @if (step()?.step.type === FORM) {
      <c-form-step
        [title]="step().step.form.title"
        [formStructure]="formControls()"
        [dynamicForm]="dynamicForm()"
        [showErrors]="showValidationMessage()"
        (formChanged)="onFormChanged($event)" />
    }
  </div>
}